var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"press-release-info"},[_c('h6',[(_vm.isInPast || !_vm.hasReleaseDate)?_c('span',{staticClass:"immediate"},[_vm._v("For immediate release")]):_c('span',{staticClass:"future"},[_vm._v("For release on:")]),(_vm.hasReleaseDate)?_c('span',[_vm._v(" "+_vm._s(_vm.date))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }